
import React from "react";
import { Clock } from "lucide-react";

interface InventoryStatusHeaderProps {
  lastUpdatedDate: string;
  lastUpdatedTime: string;
}

const InventoryStatusHeader = ({ lastUpdatedDate, lastUpdatedTime }: InventoryStatusHeaderProps) => {
  return (
    <div className="flex items-center gap-4">
      <Clock className="h-8 w-8 text-muted-foreground" />
      <div>
        <div className="text-2xl font-bold">{lastUpdatedTime}</div>
        <p className="text-sm text-muted-foreground">
          Laatst bijgewerkt op {lastUpdatedDate}
        </p>
      </div>
    </div>
  );
};

export default InventoryStatusHeader;
